// removed by extract-text-webpack-plugin
module.exports = {"marketingRegisterModal":"_28jNA","closeButton":"_-Vigu","banquetLogo":"_2GzAX","header":"_24b3t","subheader":"_11_Q1","contactForm":"_1PtXr","input":"HMSCW","invalid":"RBT6_","submitContactFormButton":"_cCNv","confirmation":"_1Sz3a","confirmationTitle":"_1khnd","confirmationMessage":"g4pu2","error":"_3RcnB","contactFormSent":"_4HVDR _1PtXr","contactFormFailed":"LEJM2 _1PtXr"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/MarketingRegisterModal/index.sass
// module id = 1485
// module chunks = 1